import {useCallback, useState} from 'react';

export interface IOpenState {
    isOpen: boolean,
    open: () => void,
    close: () => void,
}

const useOpenState = (initial = false): IOpenState => {
    const [isOpen, setIsOpen] = useState(initial);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    return {isOpen, open, close};
};

export default useOpenState;
